<!-- 停车市场分析数据 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCodeList": [
                    "765OB49GJ",
                    "765MQK2TX"
                ]
            },
            responseCode: {
                    "data": {
                        "carTrafficFlowTopVoList": [
                            {
                                "carCodePre": "粤C",
                                "carCodePreTotal": 40096,
                                "proportion": 52.8,
                                "proportionStr": "52.8%"
                            }
                        ],
                        "carTrafficFlowTotal": 75939
                    },
                    "message": "业务成功",
                    "resultCode": 0,
                    "status": 1
                }
                ,infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取车流量车牌top分布",
                t_url: this.commonUrls.test+"getCarTrafficFlowAnalysis",
                p_url: this.commonUrls.prod+"getCarTrafficFlowAnalysis",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodeList', info2: '是', info3: 'JSONArray', info4: '停车场编码列表' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carTrafficFlowTopVoList', info2: '是', info3: 'JSONArray', info4: '记录列表' },
                        { info1: 'carTrafficFlowTotal', info2: '是', info3: 'Integer', info4: '记录列表' }
                        ]
                },{
                  titleName: 'carTrafficFlowTopVoList',
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: 'carCodePre', info2: '是', info3: 'String', info4: '车牌前缀' },
                    { info1: 'carCodePreTotal', info2: '是', info3: 'String', info4: '该车牌前缀的数量' },
                    { info1: 'proportion', info2: '是', info3: 'BigDecimal', info4: '占比' },
                    { info1: 'proportionStr', info2: '是', info3: 'String', info4: '占比' },
                  ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/dataAnalysis/getCarTrafficFlowAnalysis.vue